<template>
	<by-container :showLoading="showLoading" :showNotContent="showNotContent">
		<div class="wrap clearfloat">
			<div class="mt-20">
				<div class="aboutCont  clearfloat">
					<ul class="clearfloat">
						<li class="right">
							<div class="pic"><img src="/static/img/news/1.jpg" alt="" /></div>
						</li>
						<li class="left">
							<div class="aboutContHead">
								<h3>WHO ARE WE</h3>
								<h2><span>电商服务中心</span></h2>
							</div>
							<div class="aboutTxt">
								<p>
									忻城县电子商务产业园位于县盘龙村三岔路口（原盘龙金街），其占地面积约8000平方米。具备产品展示展销、咨询服务、办公、会议、直播、残检、摄影、培训、创业孵化、物流仓储、分拣等功能。
								</p>
								<p>
									电商办公区主要是县电商服务团队办公、会议、培训等，主要为从事电商创业和服务人员提供技术支持、信息服务、营销推广、管理咨询、培训创业及其他增值业务等全面服务。
								</p>
								<p>
									企业服务区主要是为企业提供孵化服务、公共直播服务、农残检测服务以及产品摄影美工服务，为忻城电商企业健康发展奠定基础。
								</p>
							</div>
						</li>
					</ul>
					<ul>
						<li class="left">
							<div class="pic"><img src="/static/img/news/1.jpg" alt="" /></div>
						</li>
						<li class="right">
							<div class="aboutTxt">
								<p>
									产品展示展销区分为展示和展销区，展示区主要用于陈列我县农特色产品，目前已陈设我县珍珠糯玉米、乳鸽酒、百合粉、土红糖、土面条、金银花茶、蚕丝被等多种产品。展销区陈列其他产品，所有商品实现线上线下交易融合。通过电商平台销售，提高了我县农产品的线上销售价格，例如，珍珠糯玉米头从前几年的6元/公斤提高到现在的16元/公斤以上，每亩增收约2000元；土榨红糖的线上零售价也从10元/公斤提高到40元/公斤以上。电商让贫困农民享受到互联网时代带来的红利。
								</p>
								<p>
									电子商务公共服务中心成立以来，以“便民、为民、富民”为具体目标，不断完善公共服务中心各项管理规定，大力推动我县农村电子商务发展；发挥忻城县特色产品的优势，加速推动农村电子商务的发展；通过电子商务平台，带动企业转型升级，在电商快速发展的形势下，更好更快地推动忻城县经济发展。
								</p>
							</div>
						</li>
					</ul>
				</div>
				
				<div>
					<div class="aboutContHead">
						<h3>Responsibility center</h3>
						<h2><span>中心职责</span></h2>
					</div>
					<el-row class="by-center-rb">
						<el-col :span="8">
							<i class="gxyf-iconfont icon-fuwupingjia-kefu"></i>
							<p class="">电商咨询服务</p>
						</el-col>
						<el-col :span="8">
							<i class="gxyf-iconfont icon-fuwupingjia-kefu"></i>
							<p class="">代收打发</p>
						</el-col>
						<el-col :span="8">
							<i class="gxyf-iconfont icon-fuwupingjia-kefu"></i>
							<p class="">代购代销</p>
						</el-col>
						<el-col :span="8">
							<i class="gxyf-iconfont icon-fuwupingjia-kefu"></i>
							<p class="">网上缴费</p>
						</el-col>
						<el-col :span="8">
							<i class="gxyf-iconfont icon-fuwupingjia-kefu"></i>
							<p class="">保险业务</p>
						</el-col>
						<el-col :span="8">
							<i class="gxyf-iconfont icon-fuwupingjia-kefu"></i>
							<p class="">社区团购</p>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
	</by-container>
</template>

<script>
export default {
	components: {
		// 引入组件
	},
	data() {
		return {
			showLoading: false, //页面加载状态
			showNotContent: false //是否显示空
		};
	},
	props: {
		// 上级页面传递的数据
	},
	computed: {
		// 计算属性
	},
	created() {
		// 实例初始化
	},
	beforeCreate() {
		// 实例初始化之后
	},
	mounted() {
		// 实例被挂载后调用
	},
	updated() {
		// 数据更新后调用
	},
	activated() {
		// 缓存页面显示后调用
	},
	deactivated() {
		// 缓存页面隐藏后调用
	},
	methods: {},
	watch: {
		// 数据监听及回调
	}
};
</script>

<style scoped="scoped">
	.by-center-rb{padding: 20px 0;text-align: center;}
	.by-center-rb i{font-size: 40px;width: 120px;height: 120px;border-radius: 50%;background-color: #0382db;color: #FFFFFF;padding: 10px;}
	.by-center-rb p{margin: 20px 0;}
</style>
